import { Controller } from "@hotwired/stimulus"

// Keeps a colour picker and a hex text field saying the same thing. The
// picker only speaks #rrggbb, so a #rgb typed in the field is widened for
// it; anything that is not a colour yet leaves the picker where it was.
export default class extends Controller {
  static targets = ["picker", "text"]

  fromPicker() {
    this.textTarget.value = this.pickerTarget.value
  }

  fromText() {
    const value = this.textTarget.value.trim()
    const match = value.match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i)
    if (!match) return
    const hex = match[1].length === 3 ? match[1].split("").map((c) => c + c).join("") : match[1]
    this.pickerTarget.value = `#${hex.toLowerCase()}`
  }
}
